import { Component, EventEmitter, Output } from '@angular/core'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { PipelineType } from '../../../shared/model/jobs'
import { Store } from '@ngrx/store'
import { selectUserName } from '../../../state/user/user.selectors'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-pipeline-selection',
    templateUrl: './pipeline-selection.component.html',
    styleUrls: ['./pipeline-selection.component.scss'],
})
export class PipelineSelectionComponent {
    PipelineTypeEnum = PipelineType

    @Output() selectPipeline = new EventEmitter<PipelineType>()

    selectedPipeline: PipelineType | null = null
    userName$: Observable<string | null> = this.store.select(selectUserName)

    constructor(private readonly store: Store) {}

    cancel(): void {
        closeJobSelectionDialog()
    }

    select(): void {
        if (this.selectedPipeline) this.selectPipeline.emit(this.selectedPipeline)
    }
}
